import { useMemo } from 'react';
import { Container, Stack } from '@mui/material';
import { Box } from '@mui/system';
import { useLocation } from 'react-router-dom';
// react icons
import { FaRegUser } from 'react-icons/fa';
import { MdOutlineDateRange } from 'react-icons/md';
// material icons
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EventNoteIcon from '@mui/icons-material/EventNote';
import GroupIcon from '@mui/icons-material/Group';
// componenets
import { fDate1 } from '../../utils/formatTime';
import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import ViewLargeCard from '../../components/ViewLargeCard';

function ViewPolicy() {
  const location = useLocation();
  const { rowData } = location?.state || {};

  const fields = useMemo(
    () => [
      {
        label: 'Bank Name',
        value: rowData.bank?.bankName,
        icon: <EventNoteIcon className="viewLabelIcon" />
      },
      {
        label: 'Policy Name',
        value: rowData.aggrementPolicyName,
        icon: <EventNoteIcon className="viewLabelIcon" />
      },
      {
        label: 'Loan Type',
        value: rowData.loanType?.parentLoanName,
        icon: <EventNoteIcon className="viewLabelIcon" />
      },
      {
        label: 'Loan Sub Type',
        value: rowData.loanSubType?.loanName,
        icon: <EventNoteIcon className="viewLabelIcon" />
      },
      {
        label: 'Age',
        value: `${rowData.ageMin}-${rowData.ageMax}`,
        icon: <CalendarTodayIcon className="viewLabelIcon" />
      },
      {
        label: 'Employment Type',
        value: rowData.employmentSubType?.employmentSubcategoryName,
        icon: <FaRegUser className="viewLabelIcon" />
      },
      {
        label: 'Cibil Score(Min)',
        value: rowData.minCibilScore,
        icon: <GroupIcon className="viewLabelIcon" />
      },
      {
        label: 'Collateral Request',
        value: rowData.collateralRequest ? 'Yes' : 'No',
        icon: <MdOutlineDateRange className="viewLabelIcon" />
      },
      {
        label: 'Interest Rate',
        value: `${rowData.interestRateMin}-${rowData.interestRateMax}%`,
        icon: <MdOutlineDateRange className="viewLabelIcon" />
      },
      {
        label: 'Pre Processing Charge',
        value: rowData.preProcessingCharge,
        icon: <MdOutlineDateRange className="viewLabelIcon" />
      },
      {
        label: 'Down Payment',
        value: rowData.downPayment,
        icon: <MdOutlineDateRange className="viewLabelIcon" />
      },
      {
        label: 'Loan to Value Ratio',
        value: rowData.loanToValueRatio,
        icon: <MdOutlineDateRange className="viewLabelIcon" />
      },
      {
        label: 'Start Date',
        value: rowData.policyStartDate && fDate1(rowData.policyStartDate),
        icon: <MdOutlineDateRange className="viewLabelIcon" />
      },
      {
        label: 'End Date',
        value: rowData.policyEndDate && fDate1(rowData.policyEndDate),
        icon: <MdOutlineDateRange className="viewLabelIcon" />
      }
    ],
    [rowData]
  );

  return (
    <Page title="Partner Management System || Policy">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            <PageTitle info="View Policy" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>
          <ViewLargeCard title="Policy Details" fields={fields} />
        </Box>
      </Container>
    </Page>
  );
}
export default ViewPolicy;
